import { generateResolver, Modal, Notification, STATUS_TYPES, yup } from 'dyl-components';
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Form, Grid } from 'semantic-ui-react';
import campaign from 'actions/campaigns';
import './index.scss';
import { PhoneUtil } from 'utils';

export default function RefreshDialerModal({ open, onClose, campaign_id, reload }) {
  const [resultInformation, setResultInformation] = useState({
    open: false,
    data: {},
  })
  const { isRefreshingDialer } = useSelector((state) => state.campaigns)
  const { formState: { isValid, isDirty }, control, handleSubmit, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      include_results: PhoneUtil.SYSTEM_RESULT_OPTIONS.filter(option => (
        option.value !== "conference"
      )).map(option => option.value),
      include_conversions: ['exclude'],
      inactive_results: ['connected', 'voicemail_left'],
      shuffle: false,
      reset_voicemail: false
    },
    resolver: generateResolver({
      include_results: yup
        .array()
        .min(1, "Please select at least one system result")
        .required("System results are required"),

      include_conversions: yup
        .array()
        .min(1, "Please select at least one conversion")
        .required("Conversions are required"),

      inactive_results: yup.array(),
      shuffle: yup.boolean(),
      reset_voicemail: yup.boolean()
    }),
  })
  const dispatch = useDispatch()
  const submitHandler = async (data) => {
    try {
      const response = await dispatch(campaign.refreshDialer(data, null, campaign_id))
      reset()
      setResultInformation({
        open: true,
        data: {
          count: response?.count || 0,
          inactive: response?.inactive || 0,
          reset_voicemail: response?.reset_voicemail || false,
          shuffle: response?.shuffle || false,
          total: response?.total || 0,
        }
      })
    } catch (error) {
      console.error("Error refreshing dialer:", error);
      Notification.alert("Failed to refresh dialer", STATUS_TYPES.ERROR);
    }
  }
  return (
    <Modal open={open} onClose={() => {
      setResultInformation({
        open: false,
        data: {},
      })
      reset();
      onClose();
      if (reload && resultInformation.open) {
        reload();
      }
    }} size="tiny">
      <Modal.Header>
        Refresh Dialer
      </Modal.Header>
      <Modal.Content>
        {
          resultInformation.open ? <Container text className='RefreshDialerModal__Container'>
            <p className='RefreshDialerModal__Text--bold'>Total Contacts: <span className='RefreshDialerModal__Text--normal'>{resultInformation.data.total}</span></p>
            <p className='RefreshDialerModal__Text--bold'>Contacts refreshed: <span className='RefreshDialerModal__Text--normal'>{resultInformation.data.count}</span></p>
            <p className='RefreshDialerModal__Text--bold'>Contacts set to inactive: <span className='RefreshDialerModal__Text--normal'>{resultInformation.data.inactive}</span></p>
            <p className='RefreshDialerModal__Text--bold'>Shuffled Records: <span className='RefreshDialerModal__Text--normal'>{resultInformation.data.shuffle ? 'Yes' : 'No'}</span></p>
            <p className='RefreshDialerModal__Text--bold'>Reset Voicemail: <span className='RefreshDialerModal__Text--normal'>{resultInformation.data.reset_voicemail ? 'Yes' : 'No'}</span></p>
          </Container> :

            <Form noValidate loading={isRefreshingDialer}>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={8}>
                    <Controller
                      name='include_results'
                      control={control}
                      render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                          name={name}
                          value={value}
                          required
                          onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                          label='Include System Results'
                          multiple
                          options={PhoneUtil.SYSTEM_RESULT_OPTIONS.filter(option => (
                            option.value !== "conference"
                          )).map(option => ({
                            ...option,
                            key: option.value
                          }))}
                        />
                      )}
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Controller
                      name='include_conversions'
                      control={control}
                      render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                          name={name}
                          value={value}
                          required
                          onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                          label='Include Conversions'
                          multiple
                          options={[
                            { key: 'not_convertede', value: 'exclude', text: 'Not Converted' },
                            { key: 'converted', value: 'include', text: 'Converted' },
                          ]}
                        />
                      )}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Controller
                      name='inactive_results'
                      control={control}
                      render={({ field: { name, value, onChange } }) => (
                        <Form.Select
                          name={name}
                          value={value}
                          onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                          label='Set Contacts Inactive If'
                          multiple
                          options={[
                            { key: 'connected', value: 'connected', text: 'Connected' },
                            { key: 'voicemail_left', value: 'voicemail_left', text: 'Voicemail Left' },
                          ]}
                        />
                      )}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={8}>
                    <Controller
                      name='shuffle'
                      control={control}
                      render={({ field: { name, value, onChange } }) => (
                        <Form.Checkbox
                          name={name}
                          value={value}
                          onChange={(_, { name, checked }) => {
                            onChange({ target: { name, value: checked } });
                          }}
                          label='Shuffle Records'
                        />
                      )}
                    />
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Controller
                      name='reset_voicemail'
                      control={control}
                      render={({ field: { name, value, onChange } }) => (
                        <Form.Checkbox
                          name={name}
                          value={value}
                          onChange={(_, { name, checked }) => {
                            onChange({ target: { name, value: checked } });
                          }}
                          label='Reset Voicemail'
                        />
                      )}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
        }
      </Modal.Content>
      {!resultInformation.open ? <Modal.Actions
        hasSaveButton
        onSave={handleSubmit(submitHandler)}
        saveDisabled={!isValid || !isDirty || isRefreshingDialer}
        saveOptions={{ loading: isRefreshingDialer }}
      /> : <></>}
    </Modal>
  )
}
